<script setup>
const route = useRoute();

const social = [
  {
    name: "Twitter",
    href: "https://twitter.com/viminorge",
    icon: "ri:twitter-x-fill",
  },
];

// Auth pages: center logo above the card for a single, focused flow (world-class pattern)
const authPaths = ['/login', '/twofaverify', '/forgot', '/verify', '/user/manage', '/terms', '/privacy'];
const isAuthPage = computed(() => authPaths.some((path) => route.path === path || route.path.startsWith(path + '/')));
</script>

<template>
  <div class="min-h-screen flex flex-col bg-background text-foreground">
    <!-- Header: centered on auth for unified flow, left-aligned elsewhere -->
    <header
      class="flex-shrink-0 px-6 pt-6 pb-4 mx-auto w-full max-w-7xl lg:px-8"
      :class="isAuthPage ? 'flex justify-center' : ''">
      <NuxtLink
        to="/"
        class="inline-block focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background rounded-lg"
        :class="isAuthPage ? 'h-12 w-auto' : 'h-16 w-auto'"
        aria-label="VimiCrypto home">
        <VimiLogo class="w-auto h-full" alt="VimiCrypto" />
      </NuxtLink>
    </header>

    <!-- Main Content: on auth, flex center balances form between header and footer -->
    <main
      class="flex-1 mx-auto w-full max-w-7xl lg:px-8"
      :class="isAuthPage ? 'flex flex-col items-center justify-center px-4' : 'px-6'">
      <slot />
    </main>

    <!-- Footer: minimal on auth (optional — some products hide it); keep for legal/social -->
    <footer class="flex-shrink-0 py-6 border-t border-border sm:py-8">
      <div class="flex flex-col items-center justify-center gap-6 px-6 mx-auto max-w-7xl sm:flex-row lg:px-8">
        <p class="text-sm leading-7 text-muted-foreground">
          &copy; VimiCrypto. All rights reserved.
        </p>
        <div class="hidden sm:block sm:h-7 sm:w-px sm:flex-none sm:bg-border" />
        <div class="flex gap-x-4">
          <UButton
            v-for="(item, itemIdx) in social"
            target="_blank"
            :key="itemIdx"
            :to="item.href"
            variant="link"
            class="text-muted-foreground hover:text-foreground">
            <span class="sr-only">{{ item.name }}</span>
            <UIcon :name="item.icon" class="w-6 h-6" aria-hidden="true" />
          </UButton>
        </div>
      </div>
    </footer>
  </div>
</template>
